import api from "./gatewayConfig";
import proxy from "../proxy.json";
import { buildMasterActionFlags } from "./permissionSchema";

export const isLocal = api.apiMode === "local";
export const isTest = api.apiMode === "test";
export const isProd = api.apiMode === "prod";

const feVendorImpersonateByMode = proxy.feVendorImpersonateUrl ?? {};
export const feVendorImpersonateUrl =
  feVendorImpersonateByMode[api.apiMode]
  ?? feVendorImpersonateByMode.prod
  ?? feVendorImpersonateByMode.test
  ?? feVendorImpersonateByMode.local
  ?? "";

/** In test, surface HTTP status, URL and backend payload in global error overlays. */
export const verboseApiErrorsInTest = isTest;

export const errorDialogDevelopmentMode = isLocal || verboseApiErrorsInTest;

/**
 * Deployment master switches for admin areas.
 * Resolved user permissions are capped by these values in resolveUserPermissions
 * (a user cannot see a feature when the corresponding flag is false here).
 */
export const featureFlags = {
  enableDashboard: true,
  enableGestioneEcommerce: true,
  enableGestioneProdotti: true,
  enableGestioneCategorie: true,
  enableGestioneUtenti: true,
  enableGestioneTickets: true,
  enableNewsletter: true,
  enableGestioneContenuti: true,
  enableSincronizzazione: true,
  enableImpostazioni: true,
  enableManutenzioneCataloghi: true,
  enableGestioneParametri: true,
  enableConfigurazioneStripe: false, //stripe non attivo
  enableMetodiPagamento: true,
  enableGestioneBanners: true,
  enableMagazine: true,
  enableSincronizzazioneIndicizzazione: true,
  enableSincronizzazioneCacheCategorie: true,
  enableSincronizzazioneProdottiScelti: true,
  enableSincronizzazioneStripe: false, //stripe non attivo
  enableGestionePermessi: true,
};

export const actionFlags = buildMasterActionFlags();

/** Config-level action visibility (not user-scoped; prefer usePermissions().isActionVisible). */
export function isActionVisible(actionGroup, action) {
  return actionFlags?.[actionGroup]?.[action] !== false;
}
